import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import * as fromMessage from '../message/message.reducer'
import { MessageEffects } from './message.effects'
import { MessageSerializer } from './message.serializer'
import { MessageService } from './message.service'

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(
      fromMessage.FEATURE_NAME,
      fromMessage.messageReducer
    ),
    EffectsModule.forFeature([MessageEffects])
  ],
  providers: [
    MessageService,
    {
      provide: MessageSerializer,
      useClass: MessageSerializer
    }
  ],
  declarations: []
})
export class MessageModule {}
